import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {GridSummary} from 'constants/SampleConstants';
import StorableSearchInput from 'samples/storables/StorableSearchInput';
import {Title} from 'ui-library/Headers';

export interface ExistingPlatePaneProps {
  onUpdate: (paneState: Partial<ExistingPlatePaneState>) => void;
  registryId: string;
  selectedGrid?: GridSummary | null;
}

export interface ExistingPlatePaneState {
  selectedGrid: GridSummary | null;
}

export interface ExistingPlatePaneWithSetterState extends ExistingPlatePaneState {
  setSelectedGrid: (grid: GridSummary | null) => void;
}

class ExistingPlatePane extends React.Component<ExistingPlatePaneProps> {
  private handlePlateChange = (plates: Array<GridSummary>): void => {
    const selectedGrid = plates.length ? plates[0] : null;
    this.props.onUpdate({selectedGrid});
  };

  override render(): JSX.Element {
    return (
      <div {...getTestProps({component: 'ExistingPlatePane', element: 'root'})}>
        <Title>Search for plate</Title>
        <StorableSearchInput
          onChange={this.handlePlateChange}
          registryId={this.props.registryId}
          selectedStorables={this.props.selectedGrid ? [this.props.selectedGrid] : []}
          shouldAllowMultiple={false}
          storableTypes={[ModelTypeConstants.PLATE]}
        />
      </div>
    );
  }
}

export default ExistingPlatePane;
